import GridContainerBase from './_grid-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'

export default {
  name: 'GridPane',
  values: {
    style: {
      $mixin: [
        {
          configSet: GridContainerBase,
        },
        {
          configSet: FlexItemBase,
        },
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
      ],
    },
    defaultColumnSize: 'auto',
  },
  meta: {
    extendable: false,
  },
}
